export const ERROR_CODE = {
  200: '成功',
  206: '任务已经完成',
  400: '请求不正确',

  401: '用户角色未授权',

  402: '用户状态错误',
  409: '用户子路径不存在',
  410: 'BUCKET不存在',

  411: 'BUCKET无权限',

  412: 'ENDPOINT地址不合法',

  413: '库名已经存在',
  414: '表名已经存在',
  460: '查询请求格式错误',
  461: '缺少查询参数',
  468: '无法识别',
  500: '内部错误',
  506: '创建失败',
  507: '删除失败',
  508: '查询失败',
  ServiceTimeout: '请求超时'
};
